function OpacityLayer({ onClick }) {
	return <div className='opacity-layer' onClick={onClick}></div>
}

export default OpacityLayer
